<template>
    <div class="container">
        <accordion>
            <div v-for="(service, index) in services" class="dependant">
                <accordion-item>
                    <h2 slot="header">
                        Dependency on service {{index + 1}}
                        {{ service.descriptionOfService ? ' - ' + service.descriptionOfService : '' }}
                    </h2>
                    <service :index="index" @check="updateValid"></service>
                </accordion-item>
            </div>
        </accordion>
        <step-button :next-valid="stepValid"></step-button>
    </div>

</template>

<script>
    import StepButton from 'components/StepButton.vue';
    import Service from 'pages/fatal-accident-claims/dependency/steps/dependency-on-services/Service.vue';
    import Accordion from 'components/accordion/Accordion.vue';
    import AccordionItem from 'components/accordion/AccordionItem.vue';
    import { setStepValid }  from 'services/routingMethods';
    import FormValidator from 'components/form/validator/mixin.js'
    import {mapGetters, mapActions} from 'vuex';

    export default {
        mixins:[
            FormValidator,
        ],
        computed: {
            ...mapGetters('fatal/dependency/dependencyOnServices', {
                services: 'all',
                allServicesProcessed: 'allServicesProcessed'
            }),
            ...mapGetters('fatal/dependency/step', {
                step: 'currentStep'
            }),
            stepValid: {
                get() {
                    setStepValid(this.allServicesProcessed && this.$valid());
                    return this.allServicesProcessed && this.$valid()
                }
            }
        },
        components: {
            StepButton,
            Service,
            Accordion,
            AccordionItem
        },
        created() {
            if (!this.services.length) {
                this.addService();
            } else {
                this.updateTheMultiplicand()
                    .then(this.reCalcServices.bind(this))
            }
        },
        methods: {
            ...mapActions('fatal/dependency/dependencyOnServices', {
                addService: 'add',
                reCalcServices: 'reCalcServices',
                updateTheMultiplicand: 'updateTheMultiplicand'
            }),
            updateValid() {
                this.updateTheMultiplicand();
                //Set the step to valid on update
                setStepValid(this.allServicesProcessed && this.$valid());
            }
        }

    }
</script>


// WEBPACK FOOTER //
// DependencyOnServices.vue?512f5f68